var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5923 13.4734L15.0426 14.0232L15.5923 14.5729L24.696 23.6766L24.6961 23.6767C24.9847 23.9652 24.9847 24.4302 24.6961 24.7187L24.696 24.7188C24.552 24.8629 24.3643 24.9349 24.1748 24.9349L24.1741 24.9349C24.0776 24.935 23.982 24.916 23.8928 24.8791L23.5951 25.5973L23.8928 24.8791C23.8036 24.8421 23.7226 24.7879 23.6544 24.7195L23.6537 24.7188L14.5499 15.6151L14.0001 15.0654L13.4504 15.6152L4.34696 24.7188C4.20295 24.8629 4.01532 24.9349 3.82584 24.9349L3.82499 24.9349C3.72849 24.935 3.63292 24.916 3.54377 24.8791C3.45461 24.8421 3.37364 24.788 3.3055 24.7196L3.30456 24.7187C3.01596 24.4303 3.01592 23.9653 3.30459 23.6767L3.30473 23.6766L12.4081 14.5729L12.9578 14.0231L12.4081 13.4734L3.30466 4.36964L3.30452 4.36949C3.01586 4.08098 3.01586 3.61604 3.30452 3.32752L3.30465 3.32739C3.59308 3.03896 4.05794 3.03872 4.34688 3.32738C4.34693 3.32743 4.34697 3.32747 4.34702 3.32752L13.4504 12.4311L14.0001 12.9808L14.5499 12.4311L23.6537 3.32739L23.6538 3.32735C23.9422 3.03887 24.4074 3.03882 24.696 3.32739L24.6961 3.32752C24.9847 3.61595 24.9847 4.08098 24.6961 4.36953L24.696 4.36963L15.5923 13.4734Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 1.55496
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.e998182165747765e43a05361abfa600.svg";
export { ForwardRef as ReactComponent };